<template>
    <v-select
        dense
        outlined
        hide-details
        background-color="white"
        clearable
        :items="items"
        :placeholder="$t('typ')"
        v-bind="$attrs"
        v-on="$listeners"
    >
    </v-select>
</template>

<script>
import { TYPE as BannerType } from '@/models/Banner';

export default {
    name: 'BannerTypeSelect',
    created() {
        this.items = Object.entries(BannerType).map((item) => {
            return {
                value: item[0],
                text: this.$t(item[1].title_key),
            };
        });
    },
};
</script>
